@if(message) {
	<div class="popup-backdrop">
		<div class="confirm-popup-container">
			<div class="confirm-popup-header">
				<span>{{ displayTitle }}</span>
				<button class="close-btn" (click)="onConfirmRemove()" aria-label="סגור">×</button>
			</div>
			<div class="confirm-popup-content">
				<ng-content></ng-content>
				<div class="confirm-popup-message" [class.multiline]="message.includes('\n')">
					{{ message }}
				</div>
				<div class="confirm-popup-actions">
					@if (download) {
						<button class="download-btn" type="button" (click)="downloadReport()" i18n="components.popup.download_report">הורדת קובץ</button>
					}
					<button class="confirm-btn" (click)="onConfirmRemove()" i18n="components.popup.confirm">אישור</button>
				</div>
			</div>
		</div>
	</div>
}
